
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-print",
  "use": "icon-material-print-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-print\"><path d=\"M655.85-654.22v-123.63h-351.7v123.63h-68.13v-192h488.2v192zm-513.7 68.37h675.7zm592.9 100.5q13.32 0 23.04-9.67 9.71-9.67 9.71-22.96 0-13.19-9.67-23.03t-23.08-9.84q-13.31 0-23.03 9.84t-9.72 23.03q0 13.2 9.72 22.91 9.72 9.72 23.03 9.72m-79.2 307.5v-178.13h-351.7v178.13zm68.37 66.94h-488.2v-180.07h-162V-542q0-47.35 32.11-79.78 32.1-32.44 79.39-32.44h588.96q47.49 0 79.61 32.44 32.13 32.43 32.13 79.78v251.02h-162zm93.63-248.44v-183.34q0-18.67-12.47-30.91-12.47-12.25-30.9-12.25H185.52q-18.26 0-30.82 12.63-12.55 12.63-12.55 31.22v182.65h93.87v-65h488.2v65z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-print"/>
                </svg>
            );
        };

        Icon.id = "icon-material-print";

        export default Icon;
    